import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Salman Karim',
    title: "Web & App Developer",
    desciption:"So keep your eyes fixed on the horizon, your feet firmly planted, and your spirit unbreakable. Because when life tries to suck you in, you'll be ready to say, 'Bring it on.'",
    image: 'https://avatars.githubusercontent.com/u/80624021?s=400&u=f00fc03f3f957c9bdb22cf6e3d6467843e5c2d60&v=4',
    resumePdf: resume
}
